module.exports = __webpack_public_path__ + "static/img/logo.781c3064.png";